import { GetterTree } from 'vuex';
import { State } from '@/store/modules/k8/k8CommonState/k8.store';
import { KeyLabel } from '@/store/mutations-typesCommon';

const getters: GetterTree<State, State> = {
  getCurrentK8Tab(state: State): String {
    return state.currentK8Tab;
  },
  getCurrentRouteConfig(state: State): Array<any> {
    return state.currentRoute;
  },
  getCurrentK8Namespace(state: State): KeyLabel {
    return state.currentNamespace;
  },
  getCurrentK8Cluster(state: State): KeyLabel {
    return state.currentCluster;
  },
  getCurrentK8Workload(state: State): KeyLabel {
    return state.currentWorkload;
  },
  getK8Clusters(state: State): Array<KeyLabel> {
    return state.k8Clusters;
  },
  getK8Namespaces(state: State): Array<KeyLabel> {
    return state.k8Namespaces;
  },
};

export default getters;